import axios from 'axios';

// Dynamische API-URL basierend auf der Umgebung
// In der Produktionsumgebung (Docker/Server): Verwende relative URL
// In der Entwicklungsumgebung: Verwende localhost oder die Umgebungsvariable
const isProduction = process.env.NODE_ENV === 'production';
const API_URL = isProduction 
  ? '/api' 
  : (process.env.REACT_APP_API_URL || 'http://localhost:3002/api');

console.log('Using API URL:', API_URL); // Hilft bei der Fehlersuche

class AuthService {
  async login(username, password) {
    try {
      console.log('Login attempt to:', `${API_URL}/auth/login`);
      console.log('Login credentials:', { username, password: '***' });
      
      // Konfiguration für CORS
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false
      };
      
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      }, config);
      
      console.log('Login response:', response.data);
      
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        return { success: true, user: response.data.user };
      }
      return { success: false, message: 'Keine gültige Antwort vom Server' };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error details:', error.response?.data || error.message);
      
      // Detaillierte Fehlermeldung
      let errorMessage = 'Ein Fehler ist aufgetreten';
      if (error.response) {
        // Der Server hat mit einem Fehlerstatuscode geantwortet
        errorMessage = `Server-Fehler: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`;
      } else if (error.request) {
        // Die Anfrage wurde gestellt, aber keine Antwort erhalten
        errorMessage = 'Keine Antwort vom Server erhalten. Bitte überprüfen Sie Ihre Internetverbindung.';
      } else {
        // Etwas ist beim Einrichten der Anfrage schief gelaufen
        errorMessage = `Fehler bei der Anfrage: ${error.message}`;
      }
      
      return {
        success: false,
        message: errorMessage
      };
    }
  }
  
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }
  
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    return JSON.parse(userStr);
  }
  
  getToken() {
    return localStorage.getItem('authToken');
  }
  
  async isLoggedIn() {
    const token = this.getToken();
    if (!token) return false;
    try {
      const response = await axios.post(`${API_URL}/auth/validate-token`, { token });
      return response.data.success;
    } catch (error) {
      this.logout(); // Token ungültig, ausloggen
      return false;
    }
  }
  
  // Setup Axios Interceptor für automatisches Token-Handling
  setupAxiosInterceptors() {
    axios.interceptors.request.use(
      (config) => {
        const token = this.getToken();
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}

const authService = new AuthService();
authService.setupAxiosInterceptors();
export default authService;
